import { Component, Inject, OnInit, ChangeDetectorRef } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

import * as _ from "lodash";
import { Product } from "src/app/shared/models/product";
import { SpinnerService } from "src/app/shared/services/spinner.service";

@Component({
  selector: "app-product-order-modal",
  templateUrl: "./product-order-modal.component.html",
  styleUrls: ["./product-order-modal.component.scss"],
})
export class ProductOrderModalComponent implements OnInit {
  submitTopping: any[] = [];
  choosentopping: any[] = [];
  toppings: any;
  quantity:number;
  toppingPrice: number = 0;
  totalPrice: number;
  currentToppingGroup = "";
  remark:string;
  dinerName:string;
  menuMode:boolean=false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { product: Product ,menuMode:boolean},private changeDetectorRef: ChangeDetectorRef, private spinner:SpinnerService,
    private dialogRef: MatDialogRef<ProductOrderModalComponent>
  ) {}

  ngOnInit(): void {
    this.spinner.show();
    this.menuMode=this.data.menuMode;
    this.toppings = this.data.product.toppings;
    if (_.isNil(this.data.product.productQuantity)) {
      this.quantity = 1;
    }
    else{
      this.quantity=this.data.product.productQuantity;
    }

  }
  
  imageLoaded(){
    this.spinner.hide();
  }

  close() {
    this.dialogRef.close();
  }

  onAreaListControlChanged(list, group, sumSelected) {
    let topping = [];
    this.submitTopping = [];
    this.toppings[group.key].choosentopping = [];

    list.selectedOptions.selected.map((item) => {
      topping.push(item.value);
    });
    this.toppings[group.key].choosentopping = topping;
    this.toppings[group.key].sumSelected = sumSelected;
    this.calcToppings();
  }

  calcToppings() {
    this.toppingPrice = 0;
    _.each(this.toppings, (group) => {
      _.each(group.choosentopping, (topping) => {
        this.submitTopping.push(topping);
        this.toppingPrice += topping.productPrice;
      });
    });
  }

  checkIfToppingsComplete(): boolean {
    let res = true;
    _.each(this.toppings, (group) => {
      if (group.minOptions > (group.sumSelected | 0) || (group.maxOptions < (group.sumSelected | 0))) {
        group.isInvalid=true;
        res = false;
      }
    });
    return res;
  }

  checkIfToppingGroupComplete(toppingGroup): boolean {
    let res = false
    _.each(this.toppings, (group) => {
      if (group.minOptions > (group.sumSelected | 0) && toppingGroup.optionsGroupName===group.optionsGroupName) {
        res = true;
      }
    });
    return res;
  }

  addToCart(product: Product) {
    if (!this.checkIfToppingsComplete()) {
      this.changeDetectorRef.detectChanges();
      return;
    }
    // this.data.product.productPrice += this.toppingPrice;
    // this.productService.addToCart({ ...product, toppings: this.submitTopping });
    this.dialogRef.close({
      ...product,
      dinerName:this.dinerName,
      remark:this.remark,
      productQuantity:
      this.quantity,
      totalPrice:
        (this.data.product.productPrice + this.toppingPrice) *
        (this.quantity || 1),
      toppings: this.submitTopping,
    });
  }

  plus() {
    this.quantity =
      this.quantity > 0
        ? this.quantity + 1
        : 1;
  }

  minus() {
    this.quantity =
      this.quantity <= 1
        ? 1
        : this.quantity - 1;
  }
}
